import { MainPageBundleNameList } from '@/src/utils/guideBundleNameList';
import { getSecPicCache, isHitPicCacheFFPAB } from '@/src/pages/tool/sec_page_pic_cache';

const headerPicCacheObj = getSecPicCache(MainPageBundleNameList.PickUp);

export const EVENT_NAME = {
  ONSCROLL: 'onScroll',
  CELLAPPEARPREFIX: 'onCellAppear_', // 卡片出现前缀
  SCROLL_TO_TOP: 'Scroll_to_top'
};

/**
 * 渲染组件类型
 */
export const RENDER_TYPE = {
  /** 子包 */
  SUB: 'sub',
  /** 自定义组件 */
  CUSTOM: 'custom',
};

/**
* 组件吸顶
*/
export const STICKY_TYPE = {
  /** 不吸顶 （默认）*/
  0: 0,
  /** 吸顶 */
  1: 1,
};

// 主视图id
export const RootViewId = 'home-main-root';
/**
 * 子包&组件相关
 */
// 地址栏
export const AddressBarTempID = 'mach_pro_sailor_c_home_page_address_bar_sub';
// 搜索栏
export const SearchBarTempID = 'mach_pro_sailor_c_home_page_header_searchbar_sub';
// 心智头图
export const PickUpPageHeaderBgID = 'mach_pro_sailor_c_common_header_bg_sub';
// 心智头图占位
export const PickUpPageHeaderEmptyBgID = 'mach_pro_sailor_c_common_header_holder_bg_sub';
// 场景tab
export const SceneTabID = 'mach_pro_sailor_c_channel_list_header_scene_tab_sub';
// 筛选
export const FilterBarTempID = 'mach_pro_sailor_c_common_filter_bar_sub';
// 商家卡片V2
export const ProductTempIDV2 = 'mach_pro_sailor_c_home_page_home_product_card_v2_sub';
// 无数据兜底
export const PreheatTempID = 'mach_pro_sailor_c_area_preheat';
// 无更多数据: 无下拉更多数据时前端自动拼接
export const NoMoredataTempID = 'mach_pro_sailor_c_no_more_data_mach_custom';
// 二级页骨架
export const SkeletonLoadingPageID = 'mach_pro_sailor_c_sec_page_skeleton_defalut_page';
// 轮播头图组件
export const PickUpPageCarouselHeadPicID = 'pickup_carousel_banner';

/**
 * 埋点相关
 */
// 自提频道页cid
export const pickUpPageCid = 'c_sailor_c_m5n64ar9';
// 自提频道页业务标识
export const pickUpBusinessType = 'pickUp';
// 网络状态
export const noNetworkUpdateData = 'noNetworkUpdateData';
// 核心参数请求完成事件
export const homecoreCompleteEvent = 'homecore_complete_event';
/**
 * 场景tab相关
 */
// 样式
export const SCENE_TAB_DISPLAY_STYLE = {
  /** 0-金刚样式（icon + text） */
  KINGKONG: 0,
  /** 1-纯文本样式 */
  TEXT: 1,
};
// 组件高度
export const SCENE_TAB_HEIGHT = {
  /** 金刚样式高度 */
  KINGKONG_TAB_HEIGHT: 96,
  /** 文本样式高度 */
  TEXT_TAB_HEIGHT: 36,
};
// 是否吸顶
export const SCENE_TAB_STICK_TYPE = {
  /** 0-不吸顶 */
  STICK: 0,
  /** 1-吸顶 */
  NO_STICK: 1,
};

/// 默认氛围图样式
export const PickUpPageBgDefaultData = {
  component_id: PickUpPageHeaderBgID,
  component_properties: {
    render_type: 'custom'
  },
  layout_info: {},
  json_data: headerPicCacheObj ? {
    pickup_bg_pic: headerPicCacheObj.picUrl
  } : {}
};

/// 地址栏默认样式
export const AddressBarDefaultData = {
  component_id: AddressBarTempID,
  component_properties: {
    stick_type: STICKY_TYPE[1],
    render_type: RENDER_TYPE.SUB
  },
  json_data: {
    cid: pickUpPageCid,
    fromPage: pickUpBusinessType
  }
};
/// 搜索框默认样式
export const SearchBarDefaultData = {
  component_id: SearchBarTempID,
  component_properties: {
    stick_type: STICKY_TYPE[1],
    render_type: RENDER_TYPE.SUB
  },
  layout_info: {
    margin_left: 16,
    margin_right: 16
  },
  json_data: {
    cid: pickUpPageCid,
    fromPage: pickUpBusinessType
  }
};

/// 无数据兜底样式
export const PreheatItemDefaultData = {
  component_id: PreheatTempID,
  component_properties: {
    render_type: RENDER_TYPE.CUSTOM
  },
  layout_info: {},
  json_data: {
    sceneCode: 0,
    message: ''
  }
};

/**
 * 异常code码
 */
export enum HOME_PAGE_ERROR_CODE {
  PRE_PAGE_LOGIN_CODE = 201003221, // 预热页面-已登录
  PRE_PAGE_NO_LOGIN_COE = 201003222, // 预热页面-未登录
  LOGIN_CODE = 201003216, // 未开城-已登录
  NO_LOGIN_CODE = 201003217, // 未开城-未登录
  NO_SUPPLY_AREA = 201003206, // 无供给
  NO_DATA = 201003207, // 无数据
  NO_SERVICE = 201003213, // 不在服务范围：pageInfo接口在用
  LOADING = 20230505, // 加载中
}

export const HomePageEmptyImgMapping = {
  201003206: 'http://img-ap-hongkong.mykeeta.net/sailorc/d68605c40bc28693a4d073c50ab64ef19478.png',
  201003207: 'http://img-ap-hongkong.mykeeta.net/sailorc/d68605c40bc28693a4d073c50ab64ef19478.png',
  20230505: '',
};

export const PickUpListLoadingItemData = {
  component_id: PreheatTempID,
  component_properties: {
    render_type: RENDER_TYPE.CUSTOM
  },
  layout_info: {},
  json_data: {
    sceneCode: HOME_PAGE_ERROR_CODE.LOADING, // 加载中
    message: ''
  }
};

export const SkeletonPageLoadingDefaultData = {
  component_id: SkeletonLoadingPageID,
  component_properties: {
    render_type: RENDER_TYPE.CUSTOM
  },
  layout_info: {},
  json_data: {
  }
};

export const PickUpPageFirstLoadingShopListData = {
  module_header: {
    component_list: isHitPicCacheFFPAB()
      ? [PickUpPageBgDefaultData, AddressBarDefaultData, SearchBarDefaultData, PickUpPageHeaderEmptyBgID]
      : []
  },
  module_body: {
    component_list: [SkeletonPageLoadingDefaultData]
  }
};

// 子包下载失败需要降级的白名单：目前只有商家卡片
export const DegradationSubPackagesList = [
  AddressBarTempID,
  SearchBarTempID,
];

/**
 * 是否为全屏兜底
 * 未开城&无供给&其他异常
 * @param code
 */
export const isFullPreheat = (code: number): boolean => {
  if (code === 0) {
    return false;
  } else {
    if (code === HOME_PAGE_ERROR_CODE.LOGIN_CODE || code === HOME_PAGE_ERROR_CODE.NO_LOGIN_CODE || code === HOME_PAGE_ERROR_CODE.NO_SUPPLY_AREA) {
      // 未开城&无供给，兜底全屏
      return true;
    } else if (code === HOME_PAGE_ERROR_CODE.NO_DATA) {
      // 无数据，兜底非全屏，展示其他模块
      return false;
    } else {
      // 其他非0异常情况，兜底全屏
      return true;
    }
  }
};
